import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  // rackInfoList filter
  const productListTmp = params.productList.map((product) => {
    product.rackInfoList = product.rackInfoList.filter(
      (ele) => ele.quantity > 0
    )
    return product
  })

  const productList = productListTmp
    .filter((product) => {
      return product.rackInfoList.length > 0
    })
    .map((product) => {
      return {
        productId: product.productId,
        productLotNumber: commonUtil.nullEmptyFormatNull(
          product.productLotNumber
        ),
        productExpiredDate: commonUtil.nullEmptyFormatNull(
          product.productExpiredDate
        ),
        rackInfoList: product.rackInfoList
          ? (product.rackInfoList = product.rackInfoList.map((ele) => {
              return {
                quantity: String(ele.quantity),
                rackNumber: commonUtil.nullEmptyFormatNull(ele.rackNumber)
              }
            }))
          : []
      }
    })

  return {
    productList: productList,

    loadingStorageId: params.pageInfoData.storageName.value,
    loadingDate: params.pageInfoData.loadingDate,
    note: commonUtil.nullEmptyFormatNull(params.pageInfoData.remarks.data)
  }
}
export default { request }
